import type { GraphQLFormattedError } from 'graphql';

export enum ApiErrorCode {
  // Plaid/Banking errors
  DUPLICATE_ITEM = 'DUPLICATE_ITEM',
  PLAID_LINK_TOKEN_FAILED = 'PLAID_LINK_TOKEN_FAILED',
  PLAID_EXCHANGE_FAILED = 'PLAID_EXCHANGE_FAILED',

  // Generic errors
  INTERNAL_SERVER = 'INTERNAL_SERVER',
}

export function extractErrorCode(errors: readonly GraphQLFormattedError[]): ApiErrorCode {
  const code = errors[0]?.extensions?.code;

  if (typeof code === 'string' && Object.values(ApiErrorCode).includes(code as ApiErrorCode)) {
    return code as ApiErrorCode;
  }

  return ApiErrorCode.INTERNAL_SERVER;
}
